import {Dropbox} from "dropbox"
import FJErrorConstant from "../constant/FJErrorConstant";

let isTest = "www.flexclip.com" !== document.domain;
const UPLOAD_FILE_SIZE_LIMIT = 150 * 1024 * 1024;
const redirectUrl = isTest ? "https://www.smartvideomaker.com/dropbox/auth/index.html" : "https://www.flexclip.com/dropbox/auth/index.html";
let _authorizeWindow;
let _checkTime;
let _dbx = new Dropbox({clientId: "5huxbx5s3oqzbj4"});  // ax8o8580ijvtg5f

/**
 * @desc 验证用户身份
 * @private
 */
let _authentication = () => {
  return new Promise((resolve, reject) => {

    window.authorizeDropboxSuccess = ((access_token) => {
      _authorizeWindow = null;
      _dbx.setAccessToken(access_token);
      resolve();
    });

    window.authorizeDropboxFailed = (() => {
      _authorizeWindow = null;
      reject(new Error(FJErrorConstant.DROPBOX_AUTH_FAIL));
    });

    let iTop = (window.screen.availHeight - 30 - 500) / 2;
    let iLeft = (window.screen.availWidth - 10 - 500) / 2;

    let url = _dbx.getAuthenticationUrl(redirectUrl);
    _authorizeWindow = window.open(url, "Dropbox", "height=500, width=500, top=" + iTop + ", left=" + iLeft + ", toolbar=no, menubar=no, scrollbars=no, resizeable=no, location=no, status=no");
    if (_authorizeWindow) {
      _authorizeWindow.opener = window;
      _authorizeWindowOnunload().then(resolve).catch(reject);
    } else {
      reject(new Error(FJErrorConstant.DROPBOX_AUTH_FAIL));
    }
  })
}

let _clearCheckTime =() => {
  if (_checkTime !== null) {
    window.clearInterval(_checkTime);
    _checkTime = null;
  }
};

/**
 * @desc 每隔2秒检查一次验证窗口是否关闭，在登录验证时打开窗口后使用
 * @private
 */
let _authorizeWindowOnunload = function () {
  return new Promise((resolve, reject) => {
    setInterval(() => {
      if (_authorizeWindow === null) {
        _clearCheckTime();
        reject(new Error(FJErrorConstant.DROPBOX_AUTH_FAIL));
      } else if (_authorizeWindow.closed) {
        if (!_dbx.getAccessToken()) {
          _clearCheckTime();
          reject(new Error(FJErrorConstant.DROPBOX_AUTH_FAIL));
        } else {
          _clearCheckTime();
          resolve();
        }
      }
    }, 2000);
  });
};

/**
 * @desc 上传文件
 * @param {File | Blob} file
 * @param name 上传的文件名,带后缀
 * @param createAppFolder 是否创建默认的app的目录
 * @return {Promise}
 * @private
 */
let _uploadFile = async (file, name, createAppFolder = true) => {
  let path = "/" + name;
  if (createAppFolder) {
    let folderPath = "/FlexClip";
    path = folderPath + path;
    let result = await _createFolder(folderPath);
    if (!result) return {result: false, error: "create app folder failed"};
  }

  if (file.size < UPLOAD_FILE_SIZE_LIMIT) { // File is smaller than 150 Mb - use filesUpload API
    try {
      let response = await _dbx.filesUpload({path: path, contents: file, autorename: true});
      return {result: true, response};
    } catch (error) {
      console.log(error);
      return {result: false, error}
    }
  } else { // File is bigger than 150 Mb - use filesUploadSession* API
    const maxBlob = 8 * 1000 * 1000; // 8Mb - Dropbox JavaScript API suggested max file / chunk size
    let workItems = [];
    let offset = 0;

    while (offset < file.size) {
      let chunkSize = Math.min(maxBlob, file.size - offset);
      workItems.push(file.slice(offset, offset + chunkSize));
      offset += chunkSize;
    }

    try {
      let response = await workItems.reduce((acc, blob, idx, items) => {
        if (idx === 0) {

          // Starting multipart upload of file
          return acc.then(() => {
            return _dbx.filesUploadSessionStart({close: false, contents: blob})
              .then(response => response.session_id)
          });
        } else if (idx < items.length - 1) {

          // Append part to the upload session
          return acc.then((sessionId) => {
            let cursor = {session_id: sessionId, offset: idx * maxBlob};
            return _dbx.filesUploadSessionAppendV2({
              cursor: cursor,
              close: false,
              contents: blob
            }).then(() => sessionId);
          });
        } else {
          // Last chunk of data, close session
          return acc.then((sessionId) => {
            let cursor = {session_id: sessionId, offset: file.size - blob.size};
            let commit = {path: path, mode: 'add', autorename: true, mute: false};
            return _dbx.filesUploadSessionFinish({cursor: cursor, commit: commit, contents: blob});
          });
        }
      }, Promise.resolve());
      return {result: true, response};
    } catch (error) {
      console.log(error);
      return {result: false, error};
    }
  }
}

/**
 * @desc 创建文件夹
 * @param path 文件夹的路径
 * @return {Promise}
 * @private
 */
let _createFolder = async (path) => {
  try {
    await _dbx.filesListFolder({
      path,
      recursive: false,
      include_media_info: false,
      include_deleted: false,
      include_has_explicit_shared_members: false,
      include_mounted_folders: false,
      include_non_downloadable_files: false
    });
    return true;
  } catch (e) {
    console.log(e);
    try {
      await _dbx.filesCreateFolderV2({path});
      return true;
    } catch (e) {
      return false;
    }
  }
}

/**
 * @desc 通过原始的资源的路径去生成分享的link
 * @param path 原始的资源的路径
 * @return {Promise}
 * @private
 */
let _createShareLinkFromPath = async (path) => {
  try {
    let data = await _dbx.sharingCreateSharedLinkWithSettings({path: path});
    return {result: true, shareLink: data.url}
  } catch (e) {
    return {result: false, error: e};
  }
}

export default {
  authentication: _authentication,
  uploadFile: _uploadFile,
  createFolder: _createFolder,
  createShareLinkFromPath: _createShareLinkFromPath
}